import React from 'react';
import { useParams } from 'react-router-dom';
import IFramePage from 'components/core/IFramePage';
import { oldSelfServiceLink } from 'config';
import SuspensionAlertMessage from './SuspensionAlertMessage';

const CustomerEmbedFrame = (props) => {
  const { adfitNo, subTab = '' } = useParams();
  let appendedQuery;
  switch (subTab.toLowerCase()) {
    case 'suspensions':
      appendedQuery = '&subTab=Suspensions';
      break;
    case 'oneoffpayments':
      appendedQuery = '&subTab=Onex2doffx20Payments';
      break;
    case 'regularpayments':
      appendedQuery = '&subTab=Regularx20Payments';
      break;
    default:
      appendedQuery = '';
  }

  const frameLink = `${oldSelfServiceLink}/Customer/Detail?debitsuccessId=${adfitNo}&activeTab=Scheduledx20Payments${appendedQuery}&HideMenu=true`;
  return (
    <>
      <SuspensionAlertMessage />
      <IFramePage frameSrc={frameLink} appendQuery={false} />
    </>
  );
};

CustomerEmbedFrame.propTypes = {};

export default CustomerEmbedFrame;
